import React from 'react';
import { connect } from 'react-redux';
import { hot } from 'react-hot-loader';
import PageContainer from 'views/PageContainer';
import LoadingContainer from 'views/Loading/LoadingContainer';
import LoginContainer from 'views/Login/LoginContainer';
import NotFoundContainer from 'views/NotFound/NotFoundContainer';
import TosContainer from 'views/Tos/TosContainer';
import SignUpView from 'views/Login/SignUpView';
import MonitorModeView from 'views/MonitorMode/MonitorModeView';

import { NOT_FOUND } from 'redux-first-router';

const mapStateToProps = (state) => {
  const pageType = (state?.session?.settings?.user && !state.session.settings.user.acceptedTos) ? 'TOS' : state.location.type
  return {
    pageType: pageType
  }
};

const BlumiraApp = (props) => { 
  switch (props.pageType) {
    case 'LOGIN':
      return <LoginContainer />;
    case 'SIGNUP':
      return <SignUpView />;
    case 'PAGE':
      return <PageContainer />;
    case 'TOS':
      return <TosContainer />;
    case `${NOT_FOUND}`:
      return <NotFoundContainer />;
    case 'MONITORMODE':
      return <MonitorModeView />;
    default:
      return <LoadingContainer />;
  }

}

export default hot(module)(connect(mapStateToProps)(BlumiraApp))
